module.exports = __webpack_public_path__ + "img/title bar.27df43e9.png";